export const TOOLTIP_BG_COLOR = '#8712CF';
